import { connect } from 'react-redux';

import Runway from '../components/Runway';

import { getEvents, getTasks, selectEvent, deselectEvent, setRunwayBounds } from '../modules/user/actions';
import * as userSelectors from '../modules/user/selectors';

function mapStateToProps(state) {
  return {
    events: userSelectors.getEvents(state),
    tasks: userSelectors.getTasks(state),
    bounds: userSelectors.getRunwayBounds(state),
  };
}

const mapDispatchToProps = {
  getEvents,
  getTasks,
  setRunwayBounds,
  selectEvent,
  deselectEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(Runway);
